/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function DownloadIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "download", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M19.5 17V19.5H5.5V17", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M12.5 16L12.5 4.99999", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M17.5 11L12.5 16L7.5 11", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(DownloadIcon);
export default ForwardRef;
//# sourceMappingURL=downloadIcon.js.map